export const cookieName = "iAuthToken";

export const EMAIL_REGEX = new RegExp("[^@ \t\r\n]+@[^@ \t\r\n]+.[^@ \t\r\n]+");

export const timer = 6;

export const scoreMatrix = {
  level: "",
  totalTime: "",
  totalMoves: "",
  optimalMoves: "",
  averageMoveTime: "",
  isLevelCleared: false,
  isTutorialLevel: false,
  deadEndCount: "",
  resetCount: "",
  undoCount: "",
  stateOfFlow: "<JSON>",
  comment: "<String>",
  action: "zoom/startOver/thinkOutLoud",
  mood:
    "calm/neutral/bitConfused/frustrated/focused/intrigued/guilty/excited/exhausted",
  timeBeforeStart: "",
};

export const SHOVEBERRY_LEVELS_DATA = [
  {
    board: [["p", "b1", "g", "c1"]],
    dummyBoardState: [],
    dummyBerryMoves: "",
    dummyPlayerMoves: "",
    optimalMoves: 2,
    rows: 1,
    cols: 4,
    coins: ["c1"],
    berries: ["b1"],
    playerMove: { x: 0, y: 0, idx: 0, idy: 0 },
    berryMoves: {
      b1: {
        x: 0,
        y: 0,
        coinPosX: 0,
        coinPosY: 0,
      },
    },
    coinPos: {
      x: 0,
      y: 0,
    },
  },
  {
    board: [
      ["n", "n", "o", "s", "o", "n", "n", "n"],
      ["n", "n", "s", "c1", "s", "n", "n", "n"],
      ["n", "n", "o", "g", "o", "s", "o", "s"],
      ["s", "o", "s", "b1", "g", "b4", "c2", "o"],
      ["o", "c3", "g", "b2", "p", "s", "o", "s"],
      ["s", "s", "o", "s", "b3", "s", "n", "n"],
      ["n", "n", "n", "o", "c4", "o", "n", "n"],
      ["n", "n", "n", "s", "o", "s", "n", "n"],
    ],
    dummyBoardState: [],
    dummyBerryMoves: "",
    dummyPlayerMoves: "",
    optimalMoves: 11,
    coins: ["c1", "c2", "c3", "c4"],
    berries: ["b1", "b2", "b3", "b4"],
    rows: 8,
    cols: 8,
    playerMove: { x: 0, y: 0, idx: 4, idy: 4 },
    berryMoves: {
      b1: {
        x: 0,
        y: 0,
        coinPosX: 4,
        coinPosY: 4,
      },
      b2: {
        x: 0,
        y: 0,
        coinPosX: 4,
        coinPosY: 4,
      },
      b3: {
        x: 0,
        y: 0,
        coinPosX: 4,
        coinPosY: 4,
      },
      b4: {
        x: 0,
        y: 0,
        coinPosX: 4,
        coinPosY: 4,
      },
    },
    coinPos: {
      x: 0,
      y: 0,
    },
  },
  {
    board: [
      ["n", "s", "o", "s", "o", "n", "n", "n"],
      ["n", "o", "p", "g", "s", "o", "s", "n"],
      ["n", "s", "g", "b1", "g", "g", "o", "n"],
      ["s", "o", "s", "g", "s", "g", "s", "o"],
      ["o", "c1", "s", "g", "s", "g", "g", "s"],
      ["s", "c2", "b2", "g", "g", "s", "g", "o"],
      ["s", "c3", "g", "g", "g", "b3", "g", "s"],
      ["o", "s", "o", "s", "o", "s", "o", "s"],
    ],
    rows: 8,
    cols: 8,
    coins: ["c1", "c2", "c3", "c4"],
    berries: ["b1", "b2", "b3"],
    optimalMoves: 50,
    dummyBoardState: [],
    dummyBerryMoves: "",
    dummyPlayerMoves: "",
    playerMove: { x: 0, y: 0, idx: 1, idy: 2 },
    berryMoves: {
      b1: {
        x: 0,
        y: 0,
        coinPosX: 1,
        coinPosY: 2,
      },
      b2: {
        x: 0,
        y: 0,
        coinPosX: 1,
        coinPosY: 2,
      },
      b3: {
        x: 0,
        y: 0,
        coinPosX: 1,
        coinPosY: 2,
      },
    },
    coinPos: {
      x: 0,
      y: 0,
    },
  },
  {
    board: [
      ["n", "s", "o", "o", "s", "s", "s", "s", "n", "n"],
      ["n", "s", "g", "g", "g", "g", "g", "o", "o", "o"],
      ["s", "s", "b1", "s", "s", "s", "g", "g", "g", "o"],
      ["o", "g", "p", "g", "b2", "g", "g", "b3", "g", "o"],
      ["o", "g", "c1", "c2", "s", "g", "b4", "g", "s", "s"],
      ["s", "s", "c3", "c4", "s", "g", "g", "g", "s", "n"],
      ["n", "o", "s", "o", "s", "o", "s", "s", "s", "n"],
    ],
    rows: 7,
    cols: 10,
    coins: ["c1", "c2", "c3", "c4"],
    berries: ["b1", "b2", "b3", "b4"],
    optimalMoves: 116,
    playerMove: { x: 0, y: 0, idx: 3, idy: 2 },
    berryMoves: {
      b1: {
        x: 0,
        y: 0,
        coinPosX: 3,
        coinPosY: 2,
      },
      b2: {
        x: 0,
        y: 0,
        coinPosX: 3,
        coinPosY: 2,
      },
      b3: {
        x: 0,
        y: 0,
        coinPosX: 3,
        coinPosY: 2,
      },
      b4: {
        x: 0,
        y: 0,
        coinPosX: 3,
        coinPosY: 2,
      },
    },
    coinPos: {
      x: 0,
      y: 0,
    },
  },
  {
    board: [
      ["n", "n", "n", "o", "s", "s", "s", "s", "o", "o"],
      ["n", "n", "o", "o", "g", "g", "s", "g", "p", "o"],
      ["n", "n", "s", "g", "g", "g", "s", "g", "g", "o"],
      ["n", "n", "o", "b1", "g", "b2", "g", "b3", "g", "o"],
      ["n", "n", "s", "g", "b4", "s", "s", "g", "g", "s"],
      ["s", "s", "s", "g", "b5", "g", "s", "g", "s", "s"],
      ["s", "c1", "c2", "c3", "c4", "c5", "g", "g", "s", "n"],
      ["s", "s", "s", "o", "s", "o", "s", "s", "s", "n"],
    ],
    rows: 8,
    cols: 10,
    coins: ["c1", "c2", "c3", "c4", "c5"],
    berries: ["b1", "b2", "b3", "b4", "b5"],
    playerMove: { x: 0, y: 0, idx: 1, idy: 8 },
    optimalMoves: 94,
    berryMoves: {
      b1: {
        x: 0,
        y: 0,
        coinPosX: 1,
        coinPosY: 8,
      },
      b2: {
        x: 0,
        y: 0,
        coinPosX: 1,
        coinPosY: 8,
      },
      b3: {
        x: 0,
        y: 0,
        coinPosX: 1,
        coinPosY: 8,
      },
      b4: {
        x: 0,
        y: 0,
        coinPosX: 1,
        coinPosY: 8,
      },
      b5: {
        x: 0,
        y: 0,
        coinPosX: 1,
        coinPosY: 8,
      },
    },
    coinPos: {
      x: 0,
      y: 0,
    },
  },
  // {
  //   board: [
  //     ["n", "o", "o", "o", "o", "n"],
  //     ["o", "o", "g", "g", "o", "n"],
  //     ["o", "p", "b1", "g", "o", "n"],
  //     ["o", "o", "b2", "g", "o", "o"],
  //     ["o", "o", "g", "b3", "g", "o"],
  //     ["o", "c1", "b4", "g", "g", "o"],
  //     ["o", "c2", "c3", "g", "c4", "o"],
  //     ["o", "o", "o", "o", "o", "o"],
  //   ],
  //   rows: 8,
  //   cols: 6,
  //   coins: ["c1", "c2", "c3", "c4"],
  //   berries: ["b1", "b2", "b3", "b4"],
  //   dummyBoardState: [],
  //   dummyBerryMoves: "",
  //   dummyPlayerMoves: "",
  //   playerMove: { x: 0, y: 0, idx: 2, idy: 1 },
  //   berryMoves: {
  //     b1: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 2,
  //       coinPosY: 1,
  //     },
  //     b2: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 2,
  //       coinPosY: 1,
  //     },
  //     b3: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 2,
  //       coinPosY: 1,
  //     },
  //     b4: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 2,
  //       coinPosY: 1,
  //     },
  //   },
  //   coinPos: {
  //     x: 0,
  //     y: 0,
  //   },
  // },
  // {
  //   board: [
  //     ["n", "n", "n", "o", "o", "o", "o", "o", "o", "o", "n", "n", "n"],
  //     ["o", "o", "o", "o", "g", "g", "g", "g", "g", "o", "n", "n", "n"],
  //     ["o", "g", "g", "g", "c1", "o", "o", "o", "g", "o", "n", "n", "n"],
  //     ["o", "g", "o", "g", "o", "g", "g", "g", "g", "o", "o", "n", "n"],
  //     ["o", "g", "o", "g", "b1", "g", "b2", "o", "c2", "g", "o", "n", "n"],
  //     ["o", "g", "o", "g", "g", "b3", "g", "g", "o", "g", "o", "n", "n"],
  //     ["o", "g", "c3", "o", "b4", "g", "b5", "g", "o", "g", "o", "n", "n"],
  //     ["o", "o", "g", "g", "g", "g", "o", "g", "o", "g", "o", "o", "o"],
  //     ["n", "o", "g", "o", "o", "o", "c4", "g", "g", "g", "g", "p", "o"],
  //     ["n", "o", "g", "g", "g", "g", "g", "o", "o", "g", "g", "g", "o"],
  //     ["n", "o", "o", "o", "o", "o", "o", "o", "o", "o", "o", "o", "o"],
  //   ],
  //   rows: 11,
  //   cols: 13,
  //   coins: ["c1", "c2", "c3", "c4"],
  //   berries: ["b1", "b2", "b3", "b4", "b5"],
  //   dummyBoardState: [],
  //   dummyBerryMoves: "",
  //   dummyPlayerMoves: "",
  //   playerMove: { x: 0, y: 0, idx: 8, idy: 11 },
  //   berryMoves: {
  //     b1: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 8,
  //       coinPosY: 11,
  //     },
  //     b2: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 8,
  //       coinPosY: 11,
  //     },
  //     b3: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 8,
  //       coinPosY: 11,
  //     },
  //     b4: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 8,
  //       coinPosY: 11,
  //     },
  //     b5: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 8,
  //       coinPosY: 11,
  //     },
  //   },
  //   coinPos: {
  //     x: 0,
  //     y: 0,
  //   },
  // },
  // {
  //   board: [
  //     ["n", "n", "n", "o", "o", "o", "o", "o", "o", "n"],
  //     ["n", "o", "o", "o", "g", "g", "g", "g", "o", "n"],
  //     ["o", "o", "c1", "g", "b1", "o", "o", "g", "o", "o"],
  //     ["o", "c2", "c3", "b2", "g", "b3", "g", "g", "p", "o"],
  //     ["o", "c4", "c5", "g", "b4", "g", "b5", "g", "o", "o"],
  //     ["o", "o", "o", "o", "o", "o", "g", "g", "o", "n"],
  //     ["n", "n", "n", "n", "n", "o", "o", "o", "o", "n"],
  //   ],
  //   rows: 7,
  //   cols: 10,
  //   coins: ["c1", "c2", "c3", "c4", "b5"],
  //   berries: ["b1", "b2", "b3", "b4", "b5"],
  //   playerMove: { x: 0, y: 0, idx: 3, idy: 8 },
  //   berryMoves: {
  //     b1: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 3,
  //       coinPosY: 8,
  //     },
  //     b2: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 3,
  //       coinPosY: 8,
  //     },
  //     b3: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 3,
  //       coinPosY: 8,
  //     },
  //     b4: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 3,
  //       coinPosY: 8,
  //     },
  //     b5: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 3,
  //       coinPosY: 8,
  //     },
  //   },
  //   coinPos: {
  //     x: 0,
  //     y: 0,
  //   },
  // },
  // {
  //   board: [
  //     ["n", "o", "o", "o", "o", "o", "o", "o", "o", "o", "n"],
  //     ["n", "o", "g", "g", "o", "o", "g", "g", "g", "o", "n"],
  //     ["n", "o", "g", "g", "g", "b1", "g", "g", "g", "o", "n"],
  //     ["n", "o", "b2", "g", "o", "o", "o", "g", "b3", "o", "n"],
  //     ["n", "o", "g", "o", "c1", "c2", "c3", "o", "g", "o", "n"],
  //     ["o", "o", "g", "o", "c4", "c5", "c6", "o", "g", "o", "o"],
  //     ["o", "g", "b4", "g", "g", "b5", "g", "g", "b6", "g", "o"],
  //     ["o", "g", "g", "g", "g", "g", "o", "g", "p", "g", "o"],
  //     ["o", "o", "o", "o", "o", "o", "o", "o", "o", "o", "o"],
  //   ],
  //   rows: 9,
  //   cols: 11,
  //   coins: ["c1", "c2", "c3", "c4", "c5", "c6"],
  //   berries: ["b1", "b2", "b3", "b4", "b5", "b6"],
  //   playerMove: { x: 0, y: 0, idx: 7, idy: 8 },
  //   berryMoves: {
  //     b1: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 7,
  //       coinPosY: 8,
  //     },
  //     b2: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 7,
  //       coinPosY: 8,
  //     },
  //     b3: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 7,
  //       coinPosY: 8,
  //     },
  //     b4: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 7,
  //       coinPosY: 8,
  //     },
  //     b5: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 7,
  //       coinPosY: 8,
  //     },
  //     b6: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 7,
  //       coinPosY: 8,
  //     },
  //   },
  //   coinPos: {
  //     x: 0,
  //     y: 0,
  //   },
  // },
  // {
  //   board: [
  //     ["n", "n", "o", "o", "o", "o", "o", "o"],
  //     ["n", "n", "o", "g", "g", "g", "g", "o"],
  //     ["o", "o", "o", "b1", "b2", "b3", "g", "o"],
  //     ["o", "p", "g", "b4", "c1", "c2", "g", "o"],
  //     ["o", "g", "b5", "c3", "c4", "c5", "o", "o"],
  //     ["o", "o", "o", "o", "g", "g", "o", "n"],
  //     ["n", "n", "n", "o", "o", "o", "o", "n"],
  //   ],
  //   rows: 7,
  //   cols: 8,
  //   coins: ["c1", "c2", "c3", "c4", "c5"],
  //   berries: ["b1", "b2", "b3", "b4", "b5"],
  //   playerMove: { x: 0, y: 0, idx: 3, idy: 1 },
  //   berryMoves: {
  //     b1: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 3,
  //       coinPosY: 1,
  //     },
  //     b2: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 3,
  //       coinPosY: 1,
  //     },
  //     b3: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 3,
  //       coinPosY: 1,
  //     },
  //     b4: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 3,
  //       coinPosY: 1,
  //     },
  //     b5: {
  //       x: 0,
  //       y: 0,
  //       coinPosX: 3,
  //       coinPosY: 1,
  //     },
  //   },
  //   coinPos: {
  //     x: 0,
  //     y: 0,
  //   },
  // },
];
